import { Link, useNavigate } from "react-router-dom";
import PaymentSuccessful from "../../../../assets/images/PaymentIcons/PaymentSuccessful.gif";
import { useEffect } from "react";
import { useStripe } from "@stripe/react-stripe-js";
import { useState } from "react";
import { LoadingIcon } from "../../../common";
import {
  useUserSubscriptionMutation,
  useGetCompanyQuery,
  useGetClaimedMutation,
  useCreatePurchaseDetailsMutation,
} from "../../../../store/Company/companyApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { CommonToast } from "../../../common/Toast";
import { setUserInfo } from "../../../../store/auth/authSlice";
import { useCheckPaymentStatusMutation } from "../../../../store/Billing/billingApiSlice";

export const SuccessfulPayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    dispatch(setUserInfo({ ...userInfo }));
  }, [])
  const stripe = useStripe();
  const [userSubscription] = useUserSubscriptionMutation();
  const [createPurchaseDetails] = useCreatePurchaseDetailsMutation();
  const [checkPaymentStatus] = useCheckPaymentStatusMutation();
  const [verificationRequest] = useGetClaimedMutation();
  const [hasCalledAPI, setHasCalledAPI] = useState(false);
  const [redirectionType, setredirectionType] = useState("");
  const { token, userInfo } = useSelector((state) => state.auth);
  const [paymentStatus, setPaymentstatus] = useState('LOADING');

  const getPaymentStatus = async (id, setup) => {
    if (id) {
      const data = setup ? { setup_intent: id } : { payment_intent: id };
      const response = await checkPaymentStatus({ data, token });
      return response;
    }
  };
  const forCompanyVerify = new URLSearchParams(window.location.search).get(
    "companyforverify"
  );
  const forCompanyVerifyID = new URLSearchParams(window.location.search).get(
    "forverifycompid"
  );

  const individualID = userInfo?.individual?.[0]?.individualID;
  const UserID = userInfo?.individual?.[0]?.userID;
  // TIP-527 — capture once on mount. The cleanup effect below removes these
  // localStorage keys, and reading them on every render would return null after
  // the first re-render (the effect's setState re-renders the component) —
  // which sent "Open profile" to /search/null after a web-profile purchase.
  const [payforcompanyID] = useState(() => {
    try { return JSON.parse(localStorage.getItem("payasyougoCompanyID")); } catch (e) { return null; }
  });
  // TIP-493 — which web-profile flow paid (set in PaymentDetailsForm); drives the
  // success copy. Stripe's redirect drops React state, so it rides localStorage.
  const [purchaseMode] = useState(() => localStorage.getItem("webProfilePurchaseMode"));
  // TIP-556 — report order: the company doesn't exist yet (the webhook is
  // creating it), so there is no profile to open — send the user to Billing.
  // Captured once on mount, like the keys above, before the cleanup removes it.
  const [isReportRequest] = useState(() => localStorage.getItem("createWorldboxCompany") === "true");
  // A LISTED (or draft) company is not on TREVEX yet: `createWorldbox` is the
  // flag its purchase parks, and the backend reads it out of meta_data to go
  // and fetch the record. So access does NOT begin at payment — the profile
  // has to arrive first. Telling this user they "have full access ... for the
  // next 30 days" and offering "Open profile" sent them to a page that was
  // still locked. Captured once on mount like the keys above, before the
  // cleanup effect below removes it.
  const [isPendingFetch] = useState(() => localStorage.getItem("createWorldbox") === "true");
  // The name parked when the purchase started. `useGetCompanyQuery` below asks
  // `company-details/<id>`, which only knows TREVEX records — a LISTING is a
  // WorldBox one, so that lookup 404s and every line here read "this business".
  // Captured once on mount, like the keys above, before the cleanup removes it.
  const [parkedCompanyName] = useState(() => {
    try { return JSON.parse(localStorage.getItem("payasyougoCompany"))?.name || null; } catch (e) { return null; }
  });
  const [requestedCompanyName] = useState(() => {
    try { return JSON.parse(localStorage.getItem("companyDescription"))?.companyname || null; } catch (e) { return null; }
  });

  const { data } = useGetCompanyQuery({
    companyId: payforcompanyID,
    token,
  });

  useEffect(() => {
    const payment_intent = new URLSearchParams(window.location.search).get(
      "payment_intent"
    );

    localStorage.removeItem("createWorldbox")
    localStorage.removeItem("createWorldboxCompany")
    localStorage.removeItem("worldboxData")
    localStorage.removeItem("companyDescription")
    localStorage.removeItem("payasyougoCompanyID")
    localStorage.removeItem("payasyougoCompany")
    localStorage.removeItem("paycompanyStatus")
    localStorage.removeItem("UpgradePlan");
    localStorage.removeItem("webProfilePurchaseMode");
    const clientSecret = new URLSearchParams(window.location.search).get(payment_intent ? "payment_intent_client_secret" : "setup_intent_client_secret");

    let subscriptionType, subscriptionEnd, profileLimit;

    const paymentBilling = async (res) => {
      try {
        localStorage.removeItem("UpgradePlan");
        localStorage.removeItem("userInfo");
        if (forCompanyVerify !== "verify_company") {
          setredirectionType("purchase");
        } else if (forCompanyVerifyID) {
          setredirectionType("verifycompany");
        } else {
          setredirectionType("billing");
        }
      } catch (error) {
        console.error("Error fetching client secret:", error);
      }
    };

    if (clientSecret && !hasCalledAPI) {
      if (stripe && clientSecret && payment_intent) {
        stripe
          .retrievePaymentIntent(clientSecret)
          .then(async (paymentIntent) => {
            if (paymentIntent.paymentIntent?.status === "succeeded") {
              // TIP-493 (W2) — the charge is captured, so show the success
              // screen immediately. Provisioning (membership/profile) finishes
              // via the Stripe webhook moments later; we no longer block the
              // success screen on a short backend poll (which timed out to
              // "Payment Pending" under webhook latency). Fire-and-forget a
              // status check just for telemetry.
              setPaymentstatus('SUCCESS');
              paymentBilling(paymentIntent);
              getPaymentStatus(paymentIntent?.paymentIntent?.id, false);
              localStorage.removeItem("createWorldbox");
              localStorage.removeItem("worldboxData");
            } else if (paymentIntent.paymentIntent?.status === "processing") {
              setPaymentstatus('PENDING');
              paymentBilling(paymentIntent);
            } else {
              setPaymentstatus('FAILED');
              paymentBilling(paymentIntent);
            }
          });

        setHasCalledAPI(true);
      } else if (stripe && clientSecret) {
        stripe.retrieveSetupIntent(clientSecret).then(async (intent) => {
          if (intent.setupIntent?.status === "succeeded") {
            // TIP-493 (W2) — same as the payment-intent branch: confirm now,
            setPaymentstatus('SUCCESS');
            paymentBilling(intent);
            getPaymentStatus(intent?.setupIntent?.id, true);
            localStorage.removeItem("createWorldbox");
            localStorage.removeItem("worldboxData");
          }
        });

        setHasCalledAPI(true);
      }
    }
  }, [
    stripe,
    data,
    hasCalledAPI,
    userSubscription,
    individualID,
    forCompanyVerifyID,
    verificationRequest,
    token,
    UserID,
    payforcompanyID,
    createPurchaseDetails,
  ]);

  return (
    <>
      <div className="bg-[#ebf0f3]">
        {paymentStatus === 'SUCCESS' || paymentStatus === 'LOADING' ? <div>
          {redirectionType == "verifycompany" ? (
            <div className="mx-auto py-10 relative pb-40">
              <img
                src={PaymentSuccessful}
                className="mx-auto sm:w-[400px]"
                alt="payment-successful"
              />
              <h2 className="text-f24 font-extrabold">Payment Successful</h2>
              <p className="text-secondary">
                Your purchase has been completed — return to your
                <span onClick={() => { navigate("/dashboard/my-companies", { state: { userInfo: userInfo } }) }} className="text-[#002940]"> Business details</span>
              </p>
            </div>
          ) : redirectionType == "billing" ? (
            <div className="mx-auto py-10 relative pb-40">
              <img
                src={PaymentSuccessful}
                className="mx-auto sm:w-[400px]"
                alt="payment-successful"
              />
              <h2 className="text-f24 font-extrabold">Payment Successful</h2>
              <p className="text-secondary">
                Your purchase has been completed — return to your<span onClick={() => { navigate("/dashboard/billing") }} className="text-[#002940]"> Billing details</span>
              </p>
            </div>
          ) : redirectionType == "purchase" ? (
            <div className="max-w-[1100px] mx-auto px-4 py-16 text-center">
              <div className="w-14 h-14 rounded-full bg-[#E8F5E9] text-[#1A8917] text-f24 flex items-center justify-center mx-auto mb-4">
                ✓
              </div>
              {purchaseMode === "bundle" ? (
                <>
                  <h2 className="text-f24 font-bold text-primaryText">
                    {isPendingFetch
                      ? "Membership active. Web Profile request received."
                      : "Membership active. Web Profile unlocked."}
                  </h2>
                  <p className="text-secondary mt-2 max-w-[520px] mx-auto">
                    {isPendingFetch
                      ? `We are preparing ${data?.registered_company_name || parkedCompanyName || "this business"}'s web profile. Your 30 days of access start as soon as it is ready, and you can track this purchase from your Billing page. Membership is active — the Member rate applies on every TREVEX product from here on.`
                      : `You have full access to ${data?.registered_company_name || parkedCompanyName || "this business"} for the next 30 days. Membership is active — the Member rate applies on every TREVEX product from here on.`}
                  </p>
                  <div className="flex flex-wrap gap-3 justify-center mt-6">
                    {/* Nothing to open until the record arrives. */}
                    <button
                      onClick={() =>
                        navigate(
                          payforcompanyID && !isPendingFetch
                            ? `/search/${payforcompanyID}`
                            : "/dashboard/billing"
                        )
                      }
                      className="bg-primary text-white text-f14 rounded-md px-5 py-2"
                    >
                      {payforcompanyID && !isPendingFetch ? "Open profile" : "Go to Billing"}
                    </button>
                    <button
                      onClick={() => navigate("/dashboard/billing")}
                      className="border border-link text-link text-f14 rounded-md px-5 py-2"
                    >
                      View Membership benefits
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <h2 className="text-f24 font-bold text-primaryText">
                    {isReportRequest
                      ? "Order confirmed."
                      : isPendingFetch
                      ? "Web Profile request received."
                      : "Web Profile unlocked."}
                  </h2>
                  <p className="text-secondary mt-2 max-w-[520px] mx-auto">
                    {isReportRequest
                      ? `We are preparing ${requestedCompanyName || "your requested business"}'s web profile. You can track this purchase from your Billing page.`
                      : isPendingFetch
                      ? `We are preparing ${data?.registered_company_name || parkedCompanyName || "this business"}'s web profile. Your 30 days of access start as soon as it is ready, and you can track this purchase from your Billing page.`
                      : `You have full access to ${data?.registered_company_name || parkedCompanyName || "this business"} for the next 30 days.`}
                  </p>
                  <div className="flex justify-center mt-6">
                    {/* TIP-556 — report orders have no profile yet: go to Billing.
                        A listed/draft company has none yet either until the
                        WorldBox fetch lands, so it goes the same way. */}
                    {isReportRequest || isPendingFetch || !payforcompanyID ? (
                      <button
                        onClick={() => navigate("/dashboard/billing")}
                        className="bg-primary text-white text-f14 rounded-md px-5 py-2"
                      >
                        Go to Billing
                      </button>
                    ) : (
                      <button
                        onClick={() => navigate(`/search/${payforcompanyID}`)}
                        className="bg-primary text-white text-f14 rounded-md px-5 py-2"
                      >
                        Open profile
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className="mx-auto py-10 relative pb-40">
              <img
                src={PaymentSuccessful}
                className="mx-auto sm:w-[400px] hiddenlogo"
                alt="payment-successful"
              />
              <LoadingIcon />
            </div>
          )}
        </div> : paymentStatus === 'PENDING' ? (
          <div className="mx-auto py-10 relative pb-40 h-screen flex flex-col justify-center">
            {/* <img src={PaymentSuccessful} className="mx-auto sm:w-[400px]" alt="payment-successful" /> */}

            <h2 className="text-f24 font-extrabold">Payment Pending</h2>
            <p className="text-secondary">
              Your payment is taking longer than expected to confirm. If you were charged,
              it will be applied shortly — check your{" "}
              <span onClick={() => { navigate("/dashboard/purchased") }} className="text-[#002940] cursor-pointer underline"> Dashboard</span>
              {" "}or return{" "}
              <span onClick={() => { navigate("/") }} className="text-[#002940] cursor-pointer underline">Home</span>.
            </p>
          </div>
        ) : paymentStatus === 'FAILED' ? (
          <div className="mx-auto py-10 relative pb-40 h-screen flex flex-col justify-center">
            {/* <img src={PaymentSuccessful} className="mx-auto sm:w-[400px]" alt="payment-successful" /> */}
            <h2 className="text-f24 font-extrabold">Payment Failed</h2>
            <p className="text-secondary">
              Payment Failed please try again,
              <Link to="/" reloadDocument>
                <span className="text-[#002940]"> Home</span>
              </Link>
            </p>
          </div>
        ) : null}
      </div>
    </>
  );
};